import { where } from 'firebase/firestore';
import { useCollection } from '../../../firebase/hooks/useCollection';
import { useAuth } from '../../../firebase/hooks/useAuth';
import { Workspace, useWorkspace as useFirebaseWorkspace } from '../../../firebase/hooks/useWorkspace';

export const useWorkspace = () => {
  const { user } = useAuth();
  const { data: workspaces = [], loading, error } = useCollection<Workspace>(
    'workspaces',
    user ? [where('createdBy', '==', user.uid)] : [],
    { idField: 'id' }
  );
  const { createWorkspace } = useFirebaseWorkspace();

  const status = loading ? 'loading' : error ? 'error' : 'success';

  return {
    workspaces,
    status,
    createWorkspace
  };
};